import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { v4 as uuid } from 'uuid';

@Injectable()
export class UserQueryService {
    public CREATE_USER: any;

    public GET_LOGIN_USER: any;
    public GET_CURRENT_USER_DATA: any;
    public GET_ALL_USERS_DATA: any;
    public GET_USER_DATA: any;

    public UPDATE_SPECIFIC_FIELD: any;

    constructor(public apollo: Apollo) {
        /* To create user */
        this.CREATE_USER = gql` 
          mutation CREATE_USER($input: CreateUserInput!) {
            createUser(input: $input) {
                user{
                  roleId
                  userId
                 }
            }
           }
        `;

        /* To check login */
        this.GET_LOGIN_USER = gql`
          query GetUser($email:String,$password:String) {
          allUsers( condition: {email:$email,password:$password,deleteUser:null} ) {
            edges {
              node {
              firstName
              lastName
              email
              password
              createdAt
              roleId
              userId
              phoneNumber
              company                
                website
                photoUrl
                logoUrl
                roughCarpentry
                finishCarpentry
                plumbing
                electrical
                hvac
                exteriorRoofingSidingGutters
                sheetrockInstall
                sheetrockFinish
                paint
                appliances
                handymanWork
                kitchenRemodeling
                bathroomRemodeling
                roughRadio
                finishRadio
                plumbingRadio
                electricalRadio
                    hvacRadio
                exteriorRadio
                sheetrockInstallRadio
                sheetrockFinishRadio
                paintRadio
                appliancesRadio
                handymanWorkRadio
                kitchenRemodelingRadio
                bathroomRemodelingRadio
              roleByRoleId {
                  roleName
                  roleDescription
                }
              }
            }
          }
          }
          `;

        /* Get current user data */
        this.GET_CURRENT_USER_DATA = gql`
        query GetUser($userId:UUID!) {
         allUsers(condition: {userId:$userId} ) {
          edges {
            node {
             firstName
             lastName
             email         
             createdAt
             roleId
             userId
             address
             phoneNumber
             company        
             website
             photoUrl
             logoUrl
             roughCarpentry
             finishCarpentry
             plumbing
             electrical
             hvac
             exteriorRoofingSidingGutters
             sheetrockInstall
             sheetrockFinish
             paint
             appliances
             handymanWork
             kitchenRemodeling
             bathroomRemodeling
             roughRadio
       finishRadio
       plumbingRadio
       electricalRadio
         hvacRadio
       exteriorRadio
       sheetrockInstallRadio
       sheetrockFinishRadio
       paintRadio
       appliancesRadio
       handymanWorkRadio
       kitchenRemodelingRadio
       bathroomRemodelingRadio
             roleByRoleId {
                 roleName
                 roleDescription
               }
            }
          }
        }
        }
         `
            ;


        /* Get current user data */
        this.GET_USER_DATA = gql`
        query GetUser($email:String!) {
         allUsers(condition: {email:$email} ) {
          edges {
            node {
             firstName
             lastName
             email         
             createdAt
             roleId
             userId
             address
             phoneNumber
             company        
             website
             photoUrl
             logoUrl
             roughCarpentry
             finishCarpentry
             plumbing
             electrical
             hvac
             exteriorRoofingSidingGutters
             sheetrockInstall
             sheetrockFinish
             paint
             appliances
             handymanWork
             kitchenRemodeling
             bathroomRemodeling
             roughRadio
       finishRadio
       plumbingRadio
       electricalRadio
         hvacRadio
       exteriorRadio
       sheetrockInstallRadio
       sheetrockFinishRadio
       paintRadio
       appliancesRadio
       handymanWorkRadio
       kitchenRemodelingRadio
       bathroomRemodelingRadio
             roleByRoleId {
                 roleName
                 roleDescription
               }
            }
          }
        }
        }
         `
            ;

        /* Get all users */
        this.GET_ALL_USERS_DATA = gql`
                query{
                allUsers(orderBy:FIRST_NAME_ASC,condition:{deleteUser:null}) {
                    edges {
                    node {
                        roleId
                        userId
                        firstName
                        lastName
                        email
                        phoneNumber
                        address
                        createdBy
                        company                       
                        website
                        photoUrl
                        logoUrl  
                        roughCarpentry
                        finishCarpentry
                        plumbing
                        electrical
                        hvac
                        exteriorRoofingSidingGutters
                        sheetrockInstall
                        sheetrockFinish
                        paint
                        appliances
                        handymanWork
                        kitchenRemodeling
                        bathroomRemodeling 
                        roughRadio
                        finishRadio
                        plumbingRadio
                        electricalRadio
                        hvacRadio
                        exteriorRadio
                        sheetrockInstallRadio
                        sheetrockFinishRadio
                        paintRadio
                        appliancesRadio
                        handymanWorkRadio
                        kitchenRemodelingRadio
                        bathroomRemodelingRadio
                        scheduledBookingsByAssignedTo {
                        edges {
                            node {
                            buyerProperty
                            firstName
                            lastName
                            buyerAgent
                            orderType
                            insReportId
                            assignedTo
                            }
                        }
                        }
                        roleByRoleId {
                        roleName
                        roleDescription
                        }
                    }
                    }
                }
                }
                `
            ;

        this.UPDATE_SPECIFIC_FIELD = gql`
        mutation updatecontact($input:UpdateUserByUserIdInput!){
            updateUserByUserId(input:$input){
            userEdge{
                node{
                    phoneNumber
                }
            }
            }
        }`;

    }

    /* To create user */
    REGISTRATION(values, roleId, createdBy): any {
        var userId = uuid();
        return this.apollo.mutate({
            mutation: this.CREATE_USER,
            variables: {
                "input": {
                    "user": {
                        "firstName": values.firstName,
                        "lastName": values.lastName,
                        "email": values.email.toLowerCase(),
                        "password": values.password,
                        "createdAt": new Date(),
                        "userId": userId,
                        "roleId": roleId,
                        "createdBy": userId
                    }
                }
            }
        })
    }

    /* To check login */
    LOGIN(values): any {
        // console.log('values', values);
        return this.apollo.watchQuery({
            query: this.GET_LOGIN_USER,
            variables:
            {
                "email": values.username,
                "password": values.password
            },
            fetchPolicy: 'network-only'
        })
    }

    /* Get current user data */
    GET_CURRENT_USER() {
        return this.apollo
            .watchQuery({
                query: this.GET_CURRENT_USER_DATA
                ,
                variables:
                {
                    "userId": window.localStorage.getItem('userUID'),
                },
                fetchPolicy: 'network-only'
            });
    }

    /* Get all users email */
    GET_ALL_USERS_EMAIL(): any {
        return this.apollo.query({
            query: this.GET_ALL_USERS_DATA,
            fetchPolicy: 'network-only'
        })
    }

    /* Get current user data based on email */
    GET_USER(email) {
        return this.apollo
            .watchQuery({
                query: this.GET_USER_DATA
                ,
                variables:
                {
                    "email": email,
                },
                fetchPolicy: 'network-only'
            });
    }

    /** Update specific fields */
    UPDATE_SPECIFI_FIELD_BY_USERID(fieldName, fieldValue, userId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SPECIFIC_FIELD,
            variables: {
                "input": {
                    "userPatch":
                    {
                        [fieldName]: fieldValue
                    },
                    "userId": userId
                }

            },
            fetchPolicy: 'no-cache'
        })
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/users.ts